import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type EwcAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatEwcToastLabel(code: string | undefined): string {
    const t = typeof code === "string" ? code.trim() : "";
    return t.length > 0 ? t : EntityLabels.ewcCode;
}

export function getEwcAdminActionSuccessMessage(
    kind: EwcAdminConfirmKind,
    code: string | undefined
): string {
    const label = formatEwcToastLabel(code);
    const successByKind: Record<EwcAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type EwcRow = { id: string; code: string };

export const buildEwcAdminPagedListActions = (openConfirm: (kind: EwcAdminConfirmKind, item: EwcRow) => void) =>
    buildRecordLifecyclePagedListActions<EwcRow>(openConfirm, { activeMember: "isActive" });
